import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import Translate from '../../../components/Translate';
import "./index.css"
import SilverButton from "../../buttons/SilverButton";
import ChevronLeftIcon from "../../../assets/icons/ChevronLeftIcon";
import ChevronRightIcon from "../../../assets/icons/ChevronRightIcon";
import DropdownSelect from "../../form/DropdownSelect";

const getPaginationRange = (curPage, numberOfPages, showPages) => {
    const pages = new Set();

    pages.add(0);
    pages.add(numberOfPages - 1);

    const half = Math.floor(showPages / 2);
    const start = Math.max(1, curPage - half);
    const end = Math.min(numberOfPages - 2, curPage + half);

    for (let i = start; i <= end; i++) {
        pages.add(i);
    }

    const sortedPages = Array.from(pages).sort((a, b) => a - b);
    return sortedPages;
};

const TablePagination = ({
                             showPages,
                             numberOfPages,
                             curPage,
                             selectPage,
                             handleChangeRowsPerPage,
                             rowsPerPage,
                             totalRows
                         }) => {
    const pageNumbers = getPaginationRange(curPage, numberOfPages, showPages);

    return (
        <div className="table-pagination">
            <div className="table-pagination__meta">
                <span>({totalRows})</span>
                <span><Translate text="rowsPerPage"/></span>
                <DropdownSelect
                    options={[5, 10, 25, 50]}
                    selectedValue={rowsPerPage}
                    onChange={handleChangeRowsPerPage}
                    direction='top'
                    styles={{width: '82px'}}
                />
            </div>

            <div className="table-pagination__pages">
                <SilverButton
                    variant="ghost"
                    disabled={curPage === 0}
                    onClick={() => {
                        selectPage(curPage - 1);
                    }}
                    height={'36px'}
                    width={'36px'}
                    styles={{padding: 0}}
                >
                    <ChevronLeftIcon width={18} height={18} stroke="currentColor"/>
                </SilverButton>

                <ul className="no-style-list table-pagination__pages">
                    {pageNumbers.map((page, index) => {
                        const prev = pageNumbers[index - 1];
                        const showEllipsis = prev !== undefined && page - prev > 1;
                        return (
                            <React.Fragment key={page}>
                                {showEllipsis && <li className="page-ellipsis">...</li>}
                                <li
                                    className={'page-number ' + (page === curPage ? 'page-number-selected' : '')}
                                    onClick={() => {
                                        selectPage(page);
                                    }}
                                >
                                    {page + 1}
                                </li>
                            </React.Fragment>
                        );
                    })}
                </ul>

                <SilverButton
                    variant="ghost"
                    disabled={curPage + 1 >= numberOfPages}
                    onClick={() => {
                        selectPage(curPage + 1);
                    }}
                    height={'36px'}
                    width={'36px'}
                    styles={{padding: 0}}
                >
                    <ChevronRightIcon width={18} height={18} stroke="currentColor"/>
                </SilverButton>
            </div>
        </div>
    );
};

TablePagination.propTypes = {
    numberOfPages: PropTypes.number,
    curPage: PropTypes.number,
    selectPage: PropTypes.func,
    showPages: PropTypes.number,
    handleChangeRowsPerPage: PropTypes.func,
    rowsPerPage: PropTypes.number,
    totalRows: PropTypes.number,
};

TablePagination.defaultProps = {
    showPages: 3,
    rowsPerPage: 5,
};

export default Radium(TablePagination);



// WEBPACK FOOTER //
// ./src/components-new/table/TablePagination/index.jsx